import { uploadMedia, handleError } from './';
import { personalSiteLogoTagNames } from '../config';

export const sendLogos = async ({ logos, siteId }) => {
  try {
    const responses = await Promise.all(
      logos
        .filter(({ file }) => file && file instanceof File)
        .map(({ name, label, desc, file }) =>
          uploadMedia(
            { site: siteId, mc: label, [personalSiteLogoTagNames[name]]: file },
            { endpoint: '/merchant/media/upload' }
          )
        )
    );
    return responses;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
